<app-modal [titleId]="type + '-title'" (close)="close.emit()">
  <div class="status-content">
    <div class="status-icon" [class]="type + '-icon'">
      @if (type === 'success') {
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="24" r="24" fill="#f0fdf4"/>
          <circle cx="24" cy="24" r="16" fill="#22c55e"/>
          <path d="M18 24l6 6 12-12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      } @else {
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="24" r="24" fill="#fef2f2"/>
          <circle cx="24" cy="24" r="16" fill="#dc2626"/>
          <path d="M18 18l12 12M30 18l-12 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      }
    </div>

    <h2 [id]="type + '-title'" class="status-title">
      {{ type === 'success' ? 'Cobro exitoso' : 'Cobro rechazado' }}
    </h2>
    
    <p class="status-subtitle">
      @if (type === 'success') {
        Tu cobro fue realizado con éxito. 
      } @else {
        Tu cobro no pudo ser procesado.<br>Reinténtalo utilizando otra tarjeta.
      }
    </p>

    <div class="status-actions">
      <app-button 
        variant="primary" 
        [fullWidth]="true"
        (click)="close.emit()">
        {{ type === 'success' ? 'Cerrar' : 'Cerrar' }}
      </app-button>
    </div>
  </div>
</app-modal>